import React, { useEffect, useRef, useState } from "react";
import { getCarouselAdvertisements, trackAdvertisementEvent } from "../../api/advertisementService";
import "./AdCarousel.css";

const AUTO_ADVANCE_MS = 5000;

export default function AdCarousel() {
  const [ads, setAds] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);
  const timerRef = useRef(null);
  const viewedRef = useRef(new Set());

  useEffect(() => {
    getCarouselAdvertisements()
      .then(setAds)
      .catch(() => setAds([]));
  }, []);

  useEffect(() => {
    if (ads.length <= 1) return undefined;

    timerRef.current = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % ads.length);
    }, AUTO_ADVANCE_MS);

    return () => clearInterval(timerRef.current);
  }, [ads]);

  useEffect(() => {
    const ad = ads[activeIndex];
    if (!ad || viewedRef.current.has(ad.advertisementId)) return;

    viewedRef.current.add(ad.advertisementId);
    trackAdvertisementEvent(ad.advertisementId, "view");
  }, [ads, activeIndex]);

  if (ads.length === 0) return null;

  function handleAdClick(ad) {
    trackAdvertisementEvent(ad.advertisementId, "click");
    if (ad.websiteLinkUrl) {
      window.open(ad.websiteLinkUrl, "_blank", "noopener,noreferrer");
    }
  }

  return (
    <div className="ad-carousel">
      <div
        className="ad-carousel-track"
        style={{ transform: `translateX(-${activeIndex * 100}%)` }}
      >
        {ads.map((ad) => (
          <div
            key={ad.advertisementId}
            className={`ad-carousel-slide${ad.websiteLinkUrl ? " ad-carousel-slide-clickable" : ""}`}
            onClick={() => handleAdClick(ad)}
          >
            {ad.videoUrl ? (
              <video
                src={ad.videoUrl}
                className="ad-carousel-image"
                autoPlay
                muted
                loop
                playsInline
              />
            ) : (
              <img src={ad.imageUrl} alt={ad.title} className="ad-carousel-image" />
            )}
          </div>
        ))}
      </div>

      {ads.length > 1 && (
        <div className="ad-carousel-dots">
          {ads.map((ad, index) => (
            <button
              key={ad.advertisementId}
              type="button"
              className={`ad-carousel-dot${index === activeIndex ? " ad-carousel-dot-active" : ""}`}
              aria-label={`Show slide ${index + 1}`}
              onClick={() => setActiveIndex(index)}
            />
          ))}
        </div>
      )}
    </div>
  );
}
